import type { MagentoApiGetCustomerOrdersQueryResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const getCustomerOrdersEndpoint = (builder: MagentoApiBuilder) => ({
  getCustomerOrders: builder.query<MagentoApiGetCustomerOrdersQueryResponse, void>({
    query: () => ({
      method: "getCustomerOrders",
      params: [],
    }),
    providesTags: [TAGS.ORDERS],
  }),
});
